import * as Yup from "yup";
import { CommonMessages } from "./CommonMessages";

const ProjectCostValidataionSchema = Yup.object().shape({
  cost_name: Yup.string()
    .required(CommonMessages.required('CostName')),

  cost_price: Yup.number()
    .required(CommonMessages.required('CostPrice'))
    .typeError(CommonMessages.required('CostPrice')),
});

export default ProjectCostValidataionSchema;
